import React, { useEffect } from 'react';
import { useHistory, useLocation, useParams } from 'react-router';
import styled from 'styled-components';
import { Loading } from 'components/atoms/loading';
import { API_KEY } from 'services';

const StyledDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100;
`;

export const AddApiKey: React.FC = () => {
  const { apiKey } = useParams<{ apiKey: string }>();
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    localStorage.setItem(
      API_KEY,
      JSON.stringify(['api_key', apiKey, 37620, 113363]),
    );

    const searchParams = new URLSearchParams(location.search);

    const target = searchParams.get('target');
    const domain = searchParams.get('domain');
    const clearedPath = target?.replaceAll(
      `/add-api-key/${apiKey}/?domain=${domain}&`,
      '',
    );

    if (Boolean(apiKey) === true) {
      if (clearedPath !== undefined && clearedPath.length > 0) {
        history.replace({ pathname: `${clearedPath}` });
      }
    }
  }, [apiKey, location, history]);

  return (
    <StyledDiv>
      <Loading />
    </StyledDiv>
  );
};
